import React, { useContext } from 'react';
import { graphql } from 'gatsby';
import { TaxonomyContext } from '../../templates/TaxonomyContext';

import {
    BrandColor,
    GeneralImages,
    KontentNumberValue,
    KontentRichText,
    KontentStringValue,
} from '../../../types/KontentProps';
import BlogDetailMasthead from './BlogDetailMasthead';
import { PageMetadataContext } from '../../templates/PageMetaDataContext';

export interface BlogDetailMastheadProps extends GeneralImages {
    kontentItemId?: string;
    display_publish_date: KontentStringValue;
    text_background_color: BrandColor;
    text_background_opacity: KontentNumberValue;
    top_summary: KontentRichText;
}

const BlogDetailMastheadContainer: React.FC<BlogDetailMastheadProps> = (
    props
) => {
    const blogTopics = useContext(TaxonomyContext).blogTopics;
    const pageMetadata = useContext(PageMetadataContext);

    return (
        <BlogDetailMasthead
            {...props}
            blogTopics={blogTopics}
            pageMetadata={pageMetadata}
        />
    );
};

export default BlogDetailMastheadContainer;

export const fragmentBlogDetailMasthead = graphql`
    fragment BlogDetailMasthead on kontent_item_component___blog_masthead {
        elements {
            display_publish_date {
                value(formatString: "MMMM DD, YYYY")
            }
            general_large___small_image_selection__large {
                ...kontentImage
            }
            general_large___small_image_selection__small {
                ...kontentImage
            }
            text_background_color {
                ...kontentColor
            }
            text_background_opacity {
                value
            }
            top_summary {
                ...kontentRichText
            }
        }
    }
`;
